export const CREDIT_CARD_ID_NONE = 'none';
